import React, { createContext, useContext, useEffect, useState } from "react";
import {
  signUp,
  signIn,
  signOut,
  confirmSignUp,
  getCurrentUser,
  resendSignUpCode,
  resetPassword,
  confirmResetPassword,
} from "@aws-amplify/auth";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const resendCode = async (username) => {
    await resendSignUpCode({ username });
  };

  const checkUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    checkUser();
  }, []);

  const login = async (email, password) => {
    await signIn({ username: email, password: password });
    await checkUser();
  };

  const logout = async () => {
    await signOut({ global: true });
    // Clear any locally stored identifiers related to the authenticated user
    if (typeof window !== "undefined") {
      localStorage.removeItem("mb_userId");
    }
    setUser(null);
  };

  const signup = async (email, password) => {
    await signUp({
      username: email,
      password: password,
    });
  };

  const confirmSignup = async (username, code) => {
    await confirmSignUp({
      username: username,
      confirmationCode: code,
    });

   
    localStorage.removeItem('mb_userEmail');

    // After successful confirmation, create a user record in our backend
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    try {
      const resp = await fetch(`${apiBase}/users`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: username, username }),
      });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        console.error('User record creation failed:', err);
      } else {
        const data = await resp.json().catch(() => ({}));
        const createdUserId = data?.user?.userId || null;
        if (createdUserId && typeof window !== 'undefined') {
          localStorage.setItem('mb_userId', createdUserId);
        }
      }
    } catch (e) {
      console.error('User record creation error:', e);
    }
  };

   const forgotPassword = async (username) => {
    await resetPassword({ username });
  };

  const confirmPasswordReset = async (username, confirmationCode, newPassword) => {
    await confirmResetPassword({
      username,
      confirmationCode,
      newPassword,
    });
  };


  return (
    <AuthContext.Provider
      value={{ user, login, logout, signup, confirmSignup, loading, resendCode, forgotPassword, confirmPasswordReset }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
